// Translations FR / NL for B.health® Local Benefits
export const translations = {
  fr: {
    // Header
    "nav.partners": "Nos partenaires",
    "nav.savings": "Économies",
    "nav.become_partner": "Devenir partenaire",
    "nav.admin": "Admin",
    "nav.propose_offer": "Proposer une offre",
    "nav.for_merchants": "Pour les commerçants",
    "nav.become_member": "Devenir membre",

    // Hero
    "hero.badge": "Avantages membres B.health®",
    "hero.title.before": "Votre abonnement Santé ",
    "hero.title.brand": "B.health®",
    "hero.title.middle": " avec ",
    "hero.title.highlight": "bénéfices",
    "hero.subtitle": "Nos partenaires locaux soutiennent votre Santé active chez B.health®. Votre abonnement devient un véritable levier d'avantages au quotidien à Berchem-Sainte-Agathe et alentours.",
    "hero.cta_partners": "Voir les partenaires",
    "hero.cta_counter": "Calculer mes économies",

    // Members Landing Page (new B2C homepage)
    "mlp.hero.kicker": "Cercle privé · Membres {center}",
    "mlp.hero.title.1": "Votre abonnement",
    "mlp.hero.title.2": "vaut bien plus",
    "mlp.hero.title.3": "dans votre quartier.",
    "mlp.hero.subtitle": "{n} commerçants triés sur le volet à {city}, prêts à vous offrir de vrais avantages. Chaque séance, chaque café, chaque soin — votre carte {center} fait la différence.",
    "mlp.hero.cta_primary": "Calculer mes économies",
    "mlp.hero.cta_secondary": "Voir les partenaires",
    "mlp.hero.stat.partners": "partenaires locaux",
    "mlp.hero.stat.saving": "économies potentielles",
    "mlp.hero.stat.categories": "catégories",
    "mlp.hero.stat.month_suffix": "/mois",
    "mlp.partners.kicker": "Le cercle",
    "mlp.partners.title": "Vos avantages, près de chez vous.",
    "mlp.partners.subtitle": "Filtrez par catégorie, cherchez un commerçant, cliquez pour voir l'offre. Simple, rapide, local.",
    "mlp.partners.search": "Rechercher un partenaire, une offre…",
    "mlp.partners.cat_all": "Tout voir",
    "mlp.partners.empty": "Aucun résultat. Essayez une autre catégorie.",
    "mlp.partners.empty_soon": "Les premiers partenaires arrivent très bientôt — revenez vite !",
    "mlp.pro_strip.text": "Vous êtes commerçant à {city} ?",
    "mlp.pro_strip.cta": "Rejoignez le cercle",
    "mlp.app.badge": "L'app membre",
    "mlp.app.title": "Votre app. Votre carte. Vos avantages.",
    "mlp.app.desc": "Présentez votre carte membre digitale à la caisse, chez votre commerçant préféré. Simple, rapide, moderne.",

    // Value Counter
    "counter.badge": "Simulateur de valeur",
    "counter.title.before": "Le coût de votre abonnement ",
    "counter.title.highlight": "baisse significativement",
    "counter.subtitle": "Grâce à notre réseau local d'avantages négociés, votre abonnement B.health® vous rapporte chaque mois en économies concrètes chez nos partenaires.",
    "counter.plan.adult": "Adult · 69€",
    "counter.plan.junior": "Junior/Senior · 59€",
    "counter.plan.label_adult": "Plan Adult",
    "counter.plan.label_junior": "Plan Junior/Senior",
    "counter.mode.simple": "Simple",
    "counter.mode.simulation": "Simulation",
    "counter.mode.pedagogical": "Pédagogique",
    "counter.disclaimer_default": "Simulation indicative basée sur les avantages partenaires disponibles et leur utilisation.",
    "counter.monthly_sub": "Abonnement mensuel",
    "counter.displayed_price": "Prix affiché",
    "counter.total_potential": "Potentiel total du réseau",
    "counter.select_offers": "Sélectionnez 2 à 5 offres que vous utiliseriez",
    "counter.pedagogical_intro": "Si vous utilisez seulement 3 offres ce mois-ci…",
    "counter.cost_label": "Coût de votre abonnement",
    "counter.after_simple": "après potentiel total",
    "counter.after_pedagogical": "après 3 offres utilisées",
    "counter.after_n_offers": "après {n} offre{s}",
    "counter.savings": "Économies",
    "counter.per_month": "/ mois",

    // Mobile App
    "app.badge": "Votre app. Votre carte. Vos avantages.",
    "app.title.before": "Votre application mobile et votre ",
    "app.title.highlight": "carte de membre",
    "app.title.after": " liée.",
    "app.subtitle": "Dans votre poche : le suivi coach, vos cours, votre check-up — et désormais le réseau d'avantages B.health® Local Benefits. Une seule carte, tous vos bénéfices.",
    "app.feature1.title": "L'application B.health®",
    "app.feature1.desc": "Coach, check-up, cours collectifs, composition corporelle — tout votre suivi santé dans l'app.",
    "app.feature2.title": "Votre carte membre intégrée",
    "app.feature2.desc": "Votre accès au centre et au réseau de partenaires, liés à un seul compte.",
    "app.feature3.title": "Profitez instantanément",
    "app.feature3.desc": "Présentez votre carte chez le partenaire, l'avantage est appliqué.",
    "app.cta": "Télécharger l'application",

    // Partners section on landing
    "partners.badge": "Le réseau B.health",
    "partners.title.before": "{n} partenaires locaux.",
    "partners.title.after": "Des économies concrètes, en €.",

    // Partner of the month
    "potm.badge": "Partenaire du mois",
    "potm.title": "Le coup de cœur du mois",
    "potm.subtitle": "Chaque mois, nous mettons un partenaire en lumière. Profitez-en avant la rotation !",
    "potm.cta": "Découvrir l'offre",
    "potm.saving_label": "Économie",
    "potm.per_month": "par utilisation",

    // Trust strip
    "trust.verified.title": "Offres vérifiées",
    "trust.verified.desc": "Chaque partenaire est rencontré et validé par l'équipe B.health®.",
    "trust.local.title": "100% local",
    "trust.local.desc": "Berchem-Sainte-Agathe, Bruxelles — votre quartier, vos commerces.",
    "trust.included.title": "Inclus dans l'abonnement",
    "trust.included.desc": "Aucun frais supplémentaire. Votre carte B.health® suffit.",

    // Partner CTA (new copy, user-requested)
    "cta.badge": "Devenez partenaire",
    "cta.title": "Devenez partenaire, c'est gagnant-gagnant",
    "cta.body": "Votre action reste la vôtre et nous nous soutenons entre commerçants de proximité ! Plus d'activité physique et plus de santé avec nos partenaires proches de nos membres 😊",
    "cta.button": "Proposer une offre",

    // Partner card
    "card.economy": "économie",
    "card.up_to_month": "Jusqu'à {amount}€/mois",
    "card.per_use": "par utilisation",
    "card.see": "Voir",
    "card.featured": "Coup de cœur",

    // Partner detail dialog
    "dialog.offer_label": "Offre privilégiée membres",
    "dialog.estimated_value": "Valeur estimée : ~{amount}€ par utilisation",
    "dialog.about": "À propos",
    "dialog.conditions": "Conditions",
    "dialog.offer_valid_until": "Offre valable jusqu'au {date}",
    "dialog.verified": "Offre vérifiée par l'équipe B.health®",
    "dialog.claim": "Je suis membre, j'en profite",
    "dialog.directions": "Voir l'itinéraire",

    // Partners page
    "partners_page.badge": "Nos partenaires",
    "partners_page.title": "Le réseau local B.health®.",
    "partners_page.subtitle": "Restaurants, soins, sport, bien-être… Découvrez tous nos partenaires et leurs offres exclusives pour les membres.",
    "partners_page.search_placeholder": "Rechercher un partenaire, une offre…",
    "partners_page.cat_all": "Tous",
    "partners_page.no_results": "Aucun partenaire ne correspond à votre recherche.",

    // Become partner form (simplified contact)
    "become.badge": "Devenir partenaire",
    "become.title": "Contactez-nous.",
    "become.subtitle": "Laissez-nous vos coordonnées. On revient vers vous rapidement pour ouvrir votre espace partenaire privé.",
    "become.success.title": "Merci !",
    "become.success.body": "Votre demande de contact est bien reçue. L'équipe B.health® revient vers vous dans les 48h pour ouvrir votre espace privé.",
    "become.success.back": "Retour à l'accueil",
    "become.field.first_name": "Prénom *",
    "become.field.last_name": "Nom *",
    "become.field.business": "Société *",
    "become.field.phone": "Téléphone *",
    "become.field.email": "Email *",
    "become.consent.gdpr": "J'accepte que mes coordonnées soient utilisées par B.health® pour me recontacter dans le cadre d'un partenariat (RGPD). *",
    "become.consent_error": "Merci de cocher la case RGPD",
    "become.submit": "Envoyer ma demande",
    "become.sending": "Envoi en cours…",
    "become.generic_error": "Une erreur est survenue. Merci de réessayer.",
    "become.success_toast": "Demande envoyée !",
    "become.footnote": "Après validation, vous recevrez vos identifiants pour compléter votre fiche et publier votre offre directement.",

    // Footer
    "footer.description": "Le cercle d'avantages locaux réservé aux membres du centre B.health® — Avenue de la Basilique 14, 1082 Berchem-Sainte-Agathe. Plus qu'un abonnement : un réseau de partenaires de confiance à Bruxelles.",
    "footer.contact": "Contact",
    "footer.links": "Liens",
    "footer.link.partners": "Nos partenaires",
    "footer.link.become": "Devenir partenaire",
    "footer.link.admin": "Espace admin",
    "footer.rights": "Tous droits réservés",
    "footer.disclaimer": "Simulation indicative basée sur les avantages partenaires disponibles.",

    // Merchant Acquisition Landing (homepage during launch)
    "ma.nav.how": "Comment ça marche",
    "ma.nav.why": "Pourquoi",
    "ma.nav.pricing": "Tarifs",
    "ma.nav.contact": "Prendre contact",
    "ma.hero.kicker": "Commerçants locaux",
    "ma.hero.title.before": "Rejoignez ",
    "ma.hero.title.brand": "B.health® Local Benefits",
    "ma.hero.title.after": "",
    "ma.hero.subtitle": "Le nouveau cercle d'avantages qui connecte les commerçants locaux de Berchem-Sainte-Agathe aux membres actifs du centre B.health®. Visibilité locale, nouveaux clients fidèles — et c'est gratuit.",
    "ma.hero.cta_primary": "Cliquez ici pour prendre contact",
    "ma.hero.cta_secondary": "Voir comment ça marche",
    "ma.hero.trust_1": "100% local",
    "ma.hero.trust_2": "Gratuit",
    "ma.hero.trust_3": "Sans engagement",

    "ma.why.badge": "Pourquoi rejoindre",
    "ma.why.title": "Ce que vous gagnez en devenant partenaire.",
    "ma.why.1.title": "Une clientèle locale qualifiée",
    "ma.why.1.desc": "Les membres B.health® sont des Bruxellois du quartier, engagés dans leur santé et leur quotidien. Public de qualité.",
    "ma.why.2.title": "Visibilité premium",
    "ma.why.2.desc": "Fiche commerce moderne avec photos, offre, adresse. Mise en avant sur notre landing et dans l'app B.health®.",
    "ma.why.3.title": "100% gratuit",
    "ma.why.3.desc": "Rejoindre le réseau ne coûte rien. Vous maîtrisez votre offre, vous ajustez quand vous voulez.",
    "ma.why.4.title": "Vous soutenez le local",
    "ma.why.4.desc": "En créant un écosystème d'avantages entre commerçants voisins, nous renforçons tout le tissu local.",

    "ma.how.badge": "Comment ça marche",
    "ma.how.title": "3 étapes — moins de 5 minutes.",
    "ma.how.1.title": "Prenez contact",
    "ma.how.1.desc": "Remplissez le formulaire (nom, prénom, commerce, email, téléphone). Pas plus.",
    "ma.how.2.title": "Nous vous validons",
    "ma.how.2.desc": "Notre équipe vous contacte, valide votre dossier et vous envoie vos identifiants par email.",
    "ma.how.3.title": "Publiez votre offre",
    "ma.how.3.desc": "Depuis votre espace privé, vous complétez votre fiche, publiez votre offre, ajoutez vos photos. C'est vivant.",

    "ma.pricing.badge": "Tarifs",
    "ma.pricing.title": "Simple et transparent.",
    "ma.pricing.free.title": "Autonome",
    "ma.pricing.free.price": "Gratuit",
    "ma.pricing.free.desc": "Vous remplissez votre fiche vous-même via votre espace privé. Toutes les fonctions incluses.",
    "ma.pricing.free.bullets": "Fiche commerce · Photos · Offre modifiable · Visibilité app & web",
    "ma.pricing.done.title": "On le fait pour vous",
    "ma.pricing.done.price": "25€ HTVA",
    "ma.pricing.done.desc": "Pas le temps ? Notre équipe crée votre fiche complète avec un joli visuel, optimise l'offre et publie pour vous.",
    "ma.pricing.done.bullets": "Rédaction · Intégration photo · Optimisation de l'offre · Mise en ligne",

    "ma.final.kicker": "Prêt à rejoindre le cercle ?",
    "ma.final.title": "Prenons contact dès maintenant.",
    "ma.final.desc": "Remplissez le formulaire, nous vous répondons sous 48h ouvrées.",
    "ma.final.cta": "Cliquez ici pour prendre contact",
    "ma.final.contact_label": "Ou contactez-nous directement :",

    // Referral / Network advantage (visitors arriving via a partner merchant)
    "referral.kicker": "Avantage réseau",
    "referral.b2b.title": "Vos clients deviennent membres {center} avec −{pct}%",
    "referral.b2b.subtitle": "Toute personne non membre {center} qui pousse la porte de notre centre via votre commerce profite d'une remise sur son abonnement annuel. Une vraie raison pour vos clients de franchir le pas — et un argument de plus pour eux comme pour vous.",
    "referral.b2c.title": "Vous venez de la part d'un commerçant partenaire ?",
    "referral.b2c.subtitle": "Profitez de −{pct}% sur votre abonnement {center} {period}, exclusivement réservé aux nouveaux membres apportés par notre réseau de commerçants locaux.",
    "referral.discount_label": "−{pct}% sur l'abonnement",
    "referral.annual": "abonnement {period}",
    "referral.note": "*Offre réservée aux nouveaux membres, valable uniquement sur les abonnements annuels (option semestrielle disponible selon centre).",
    "referral.cta_b2c": "Découvrir l'abonnement",

    // Welcome Popup
    "pop.kicker": "Bienvenue",
    "pop.title_1": "Merci",
    "pop.title_2": " pour votre intérêt.",
    "pop.lead": "B.health® Local Benefits, c'est avant tout un projet de quartier : connecter les commerçants locaux et les membres actifs pour créer des synergies concrètes.",
    "pop.pillar_1.title": "Local d'abord",
    "pop.pillar_1.desc": "Berchem-Sainte-Agathe et Bruxelles. Votre quartier, vos commerces, vos voisins.",
    "pop.pillar_2.title": "Frais minimum",
    "pop.pillar_2.desc": "Rejoindre le réseau est gratuit. On enlève les barrières, on garde l'impact.",
    "pop.pillar_3.title": "Efficacité maximum",
    "pop.pillar_3.desc": "Chaque commerçant renforce le voisin, chaque offre enrichit la communauté.",
    "pop.punch": "Frais minimum · Efficacité maximum · Ensemble.",
    "pop.cta": "Je prends contact",
    "pop.dismiss": "Découvrir le site",

    // Redeem popup (shown when merchant card CTA clicked)
    "redeem.title": "Profitez de votre avantage",
    "redeem.step_title": "En 2 secondes chez le commerçant :",
    "redeem.step_1": "Présentez l'application B.health® active sur votre smartphone",
    "redeem.step_2": "Mentionnez l'offre en caisse",
    "redeem.step_3": "Profitez immédiatement de votre réduction",
    "redeem.tip": "Rendez-vous chez votre commerçant avec votre application mobile du club et le tour est joué !",
    "redeem.close": "Compris, merci",
  },
  nl: {
    // Header
    "nav.partners": "Onze partners",
    "nav.savings": "Besparingen",
    "nav.become_partner": "Word partner",
    "nav.admin": "Admin",
    "nav.propose_offer": "Bied een voordeel aan",
    "nav.for_merchants": "Voor handelaars",
    "nav.become_member": "Word lid",

    // Hero
    "hero.badge": "B.health®-ledenvoordelen",
    "hero.title.before": "Uw gezondheidsabonnement ",
    "hero.title.brand": "B.health®",
    "hero.title.middle": " met ",
    "hero.title.highlight": "voordelen",
    "hero.subtitle": "Onze lokale partners ondersteunen uw actieve gezondheid bij B.health®. Uw abonnement wordt een echte bron van dagelijkse voordelen in Sint-Agatha-Berchem en omgeving.",
    "hero.cta_partners": "Bekijk de partners",
    "hero.cta_counter": "Bereken mijn besparingen",

    // Members Landing Page (new B2C homepage - NL)
    "mlp.hero.kicker": "Privékring · {center}-leden",
    "mlp.hero.title.1": "Uw abonnement",
    "mlp.hero.title.2": "is veel meer waard",
    "mlp.hero.title.3": "in uw buurt.",
    "mlp.hero.subtitle": "{n} zorgvuldig geselecteerde handelaars in {city}, klaar om u echte voordelen te bieden. Elke sessie, elke koffie, elke behandeling — uw {center}-kaart maakt het verschil.",
    "mlp.hero.cta_primary": "Bereken mijn besparingen",
    "mlp.hero.cta_secondary": "Bekijk de partners",
    "mlp.hero.stat.partners": "lokale partners",
    "mlp.hero.stat.saving": "potentiële besparingen",
    "mlp.hero.stat.categories": "categorieën",
    "mlp.hero.stat.month_suffix": "/maand",
    "mlp.partners.kicker": "De kring",
    "mlp.partners.title": "Uw voordelen, dicht bij u.",
    "mlp.partners.subtitle": "Filter op categorie, zoek een handelaar, klik om het aanbod te zien. Eenvoudig, snel, lokaal.",
    "mlp.partners.search": "Zoek een partner, een aanbod…",
    "mlp.partners.cat_all": "Alles zien",
    "mlp.partners.empty": "Geen resultaten. Probeer een andere categorie.",
    "mlp.partners.empty_soon": "De eerste partners komen zeer binnenkort — kom snel terug!",
    "mlp.pro_strip.text": "Bent u handelaar in {city}?",
    "mlp.pro_strip.cta": "Vervoeg de kring",
    "mlp.app.badge": "De ledenapp",
    "mlp.app.title": "Uw app. Uw kaart. Uw voordelen.",
    "mlp.app.desc": "Toon uw digitale lidkaart aan de kassa, bij uw favoriete handelaar. Eenvoudig, snel, modern.",

    // Value Counter
    "counter.badge": "Waardesimulator",
    "counter.title.before": "De kostprijs van uw abonnement ",
    "counter.title.highlight": "daalt aanzienlijk",
    "counter.subtitle": "Dankzij ons lokale netwerk van onderhandelde voordelen levert uw B.health®-abonnement u elke maand concrete besparingen op bij onze partners.",
    "counter.plan.adult": "Adult · 69€",
    "counter.plan.junior": "Junior/Senior · 59€",
    "counter.plan.label_adult": "Plan Adult",
    "counter.plan.label_junior": "Plan Junior/Senior",
    "counter.mode.simple": "Eenvoudig",
    "counter.mode.simulation": "Simulatie",
    "counter.mode.pedagogical": "Pedagogisch",
    "counter.disclaimer_default": "Indicatieve simulatie op basis van de beschikbare partnervoordelen en hun gebruik.",
    "counter.monthly_sub": "Maandelijks abonnement",
    "counter.displayed_price": "Weergegeven prijs",
    "counter.total_potential": "Totaal netwerkpotentieel",
    "counter.select_offers": "Selecteer 2 tot 5 aanbiedingen die u zou gebruiken",
    "counter.pedagogical_intro": "Als u deze maand slechts 3 aanbiedingen gebruikt…",
    "counter.cost_label": "Kostprijs van uw abonnement",
    "counter.after_simple": "na totaal potentieel",
    "counter.after_pedagogical": "na 3 gebruikte aanbiedingen",
    "counter.after_n_offers": "na {n} aanbieding{s}",
    "counter.savings": "Besparingen",
    "counter.per_month": "/ maand",

    // Mobile App
    "app.badge": "Uw app. Uw kaart. Uw voordelen.",
    "app.title.before": "Uw mobiele applicatie en uw gekoppelde ",
    "app.title.highlight": "ledenkaart",
    "app.title.after": ".",
    "app.subtitle": "In uw zak: coachbegeleiding, groepslessen, check-up — en vanaf nu het B.health® Local Benefits-netwerk. Eén kaart, alle voordelen.",
    "app.feature1.title": "De B.health®-app",
    "app.feature1.desc": "Coach, check-up, groepslessen, lichaamscompositie — uw volledige gezondheidstraject in de app.",
    "app.feature2.title": "Uw geïntegreerde ledenkaart",
    "app.feature2.desc": "Uw toegang tot het centrum en het partnernetwerk, gekoppeld aan één account.",
    "app.feature3.title": "Geniet meteen",
    "app.feature3.desc": "Toon uw kaart bij de partner, het voordeel wordt toegepast.",
    "app.cta": "Download de app",

    // Partners section
    "partners.badge": "Het B.health-netwerk",
    "partners.title.before": "{n} lokale partners.",
    "partners.title.after": "Concrete besparingen, in €.",

    // Partner of the month
    "potm.badge": "Partner van de maand",
    "potm.title": "Onze favoriet van de maand",
    "potm.subtitle": "Elke maand zetten we één partner in de kijker. Profiteer ervan vóór de volgende rotatie!",
    "potm.cta": "Ontdek de aanbieding",
    "potm.saving_label": "Besparing",
    "potm.per_month": "per gebruik",

    // Trust strip
    "trust.verified.title": "Geverifieerde aanbiedingen",
    "trust.verified.desc": "Elke partner wordt ontmoet en gevalideerd door het B.health®-team.",
    "trust.local.title": "100% lokaal",
    "trust.local.desc": "Sint-Agatha-Berchem, Brussel — uw wijk, uw handelaars.",
    "trust.included.title": "Inbegrepen in het abonnement",
    "trust.included.desc": "Geen extra kosten. Uw B.health®-kaart volstaat.",

    // Partner CTA
    "cta.badge": "Word partner",
    "cta.title": "Word partner, het is win-win",
    "cta.body": "Uw actie blijft van u en we steunen elkaar als lokale handelaars! Meer beweging en meer gezondheid met onze partners dicht bij onze leden 😊",
    "cta.button": "Bied een voordeel aan",

    // Partner card
    "card.economy": "besparing",
    "card.up_to_month": "Tot {amount}€/maand",
    "card.per_use": "per gebruik",
    "card.see": "Bekijken",
    "card.featured": "Favoriet",

    // Partner detail dialog
    "dialog.offer_label": "Exclusief ledenvoordeel",
    "dialog.estimated_value": "Geschatte waarde: ~{amount}€ per gebruik",
    "dialog.about": "Over",
    "dialog.conditions": "Voorwaarden",
    "dialog.offer_valid_until": "Aanbieding geldig tot {date}",
    "dialog.verified": "Aanbieding geverifieerd door het B.health®-team",
    "dialog.claim": "Ik ben lid, ik geniet ervan",
    "dialog.directions": "Route bekijken",

    // Partners page
    "partners_page.badge": "Onze partners",
    "partners_page.title": "Het lokale B.health®-netwerk.",
    "partners_page.subtitle": "Restaurants, verzorging, sport, welzijn… Ontdek al onze partners en hun exclusieve aanbiedingen voor leden.",
    "partners_page.search_placeholder": "Zoek een partner, een aanbieding…",
    "partners_page.cat_all": "Alle",
    "partners_page.no_results": "Geen enkele partner komt overeen met uw zoekopdracht.",

    // Become partner form (simplified contact)
    "become.badge": "Word partner",
    "become.title": "Neem contact op.",
    "become.subtitle": "Laat ons uw gegevens achter. We contacteren u snel om uw privé-partnerruimte te openen.",
    "become.success.title": "Bedankt!",
    "become.success.body": "Uw contactaanvraag is goed ontvangen. Het B.health®-team neemt binnen 48 uur contact met u op om uw privé-ruimte te openen.",
    "become.success.back": "Terug naar home",
    "become.field.first_name": "Voornaam *",
    "become.field.last_name": "Naam *",
    "become.field.business": "Bedrijf *",
    "become.field.phone": "Telefoon *",
    "become.field.email": "E-mail *",
    "become.consent.gdpr": "Ik ga ermee akkoord dat mijn gegevens door B.health® worden gebruikt om mij te contacteren in het kader van een partnerschap (GDPR). *",
    "become.consent_error": "Gelieve het GDPR-vakje aan te vinken",
    "become.submit": "Mijn aanvraag verzenden",
    "become.sending": "Bezig met verzenden…",
    "become.generic_error": "Er is een fout opgetreden. Gelieve opnieuw te proberen.",
    "become.success_toast": "Aanvraag verzonden!",
    "become.footnote": "Na validatie ontvangt u uw inloggegevens om uw fiche in te vullen en uw voordeel direct te publiceren.",

    // Footer
    "footer.description": "De kring van lokale voordelen voorbehouden aan leden van het B.health®-centrum — Basilieklaan 14, 1082 Sint-Agatha-Berchem. Meer dan een abonnement: een netwerk van vertrouwde partners in Brussel.",
    "footer.contact": "Contact",
    "footer.links": "Links",
    "footer.link.partners": "Onze partners",
    "footer.link.become": "Word partner",
    "footer.link.admin": "Adminruimte",
    "footer.rights": "Alle rechten voorbehouden",
    "footer.disclaimer": "Indicatieve simulatie op basis van de beschikbare partnervoordelen.",

    // Merchant Acquisition Landing (homepage during launch)
    "ma.nav.how": "Hoe het werkt",
    "ma.nav.why": "Waarom",
    "ma.nav.pricing": "Tarieven",
    "ma.nav.contact": "Neem contact op",
    "ma.hero.kicker": "Lokale handelaars",
    "ma.hero.title.before": "Word partner van ",
    "ma.hero.title.brand": "B.health® Local Benefits",
    "ma.hero.title.after": "",
    "ma.hero.subtitle": "De nieuwe voordelenkring die lokale handelaars in Sint-Agatha-Berchem verbindt met de actieve leden van het B.health®-centrum. Lokale zichtbaarheid, nieuwe trouwe klanten — en het is gratis.",
    "ma.hero.cta_primary": "Klik hier om contact op te nemen",
    "ma.hero.cta_secondary": "Bekijk hoe het werkt",
    "ma.hero.trust_1": "100% lokaal",
    "ma.hero.trust_2": "Gratis",
    "ma.hero.trust_3": "Geen verplichting",

    "ma.why.badge": "Waarom meedoen",
    "ma.why.title": "Wat u wint als partner.",
    "ma.why.1.title": "Een gekwalificeerd lokaal publiek",
    "ma.why.1.desc": "B.health®-leden zijn Brusselaars uit de buurt, begaan met hun gezondheid en dagelijks leven. Kwalitatief publiek.",
    "ma.why.2.title": "Premium zichtbaarheid",
    "ma.why.2.desc": "Moderne handelsfiche met foto's, aanbieding en adres. Uitgelicht op onze landingspagina en in de B.health®-app.",
    "ma.why.3.title": "100% gratis",
    "ma.why.3.desc": "Deelnemen aan het netwerk kost niets. U beheert uw aanbod en past het aan wanneer u wilt.",
    "ma.why.4.title": "U steunt het lokale leven",
    "ma.why.4.desc": "Door een voordelen-ecosysteem tussen naburige handelaars te creëren, versterken we het hele lokale weefsel.",

    "ma.how.badge": "Hoe het werkt",
    "ma.how.title": "3 stappen — minder dan 5 minuten.",
    "ma.how.1.title": "Neem contact op",
    "ma.how.1.desc": "Vul het formulier in (naam, voornaam, handelszaak, e-mail, telefoon). Niets meer.",
    "ma.how.2.title": "Wij valideren",
    "ma.how.2.desc": "Ons team neemt contact op, valideert uw dossier en stuurt u uw inloggegevens per e-mail.",
    "ma.how.3.title": "Publiceer uw aanbod",
    "ma.how.3.desc": "Via uw privéruimte vult u uw fiche aan, publiceert u uw aanbieding en voegt u foto's toe. Levendig en dynamisch.",

    "ma.pricing.badge": "Tarieven",
    "ma.pricing.title": "Eenvoudig en transparant.",
    "ma.pricing.free.title": "Autonoom",
    "ma.pricing.free.price": "Gratis",
    "ma.pricing.free.desc": "U vult uw fiche zelf in via uw privéruimte. Alle functies inbegrepen.",
    "ma.pricing.free.bullets": "Handelsfiche · Foto's · Aanpasbare aanbieding · Zichtbaarheid web & app",
    "ma.pricing.done.title": "Wij doen het voor u",
    "ma.pricing.done.price": "25€ excl. btw",
    "ma.pricing.done.desc": "Geen tijd? Ons team maakt uw volledige fiche met mooie visuals, optimaliseert het aanbod en publiceert voor u.",
    "ma.pricing.done.bullets": "Redactie · Foto-integratie · Optimalisatie · Publicatie",

    "ma.final.kicker": "Klaar om de kring te vervoegen?",
    "ma.final.title": "Laten we nu contact opnemen.",
    "ma.final.desc": "Vul het formulier in, wij reageren binnen 48 werkuren.",
    "ma.final.cta": "Klik hier om contact op te nemen",
    "ma.final.contact_label": "Of neem rechtstreeks contact op:",

    // Referral / Network advantage (NL)
    "referral.kicker": "Netwerkvoordeel",
    "referral.b2b.title": "Uw klanten worden {center}-leden met −{pct}%",
    "referral.b2b.subtitle": "Iedere niet-{center}-lid die via uw zaak de deur van ons centrum binnenstapt, krijgt korting op zijn jaarabonnement. Een echte reden voor uw klanten om de stap te zetten — en een extra argument voor hen én voor u.",
    "referral.b2c.title": "U komt van een partnerhandelaar?",
    "referral.b2c.subtitle": "Geniet van −{pct}% op uw {period} {center}-abonnement, exclusief voor nieuwe leden aangebracht door ons netwerk van lokale handelaars.",
    "referral.discount_label": "−{pct}% op het abonnement",
    "referral.annual": "{period} abonnement",
    "referral.note": "*Aanbod voorbehouden aan nieuwe leden, enkel geldig op jaarabonnementen (halfjaarlijkse optie beschikbaar afhankelijk van het centrum).",
    "referral.cta_b2c": "Ontdek het abonnement",

    // Welcome Popup
    "pop.kicker": "Welkom",
    "pop.title_1": "Bedankt",
    "pop.title_2": " voor uw interesse.",
    "pop.lead": "B.health® Local Benefits is vooral een buurtproject: lokale handelaars en actieve leden verbinden om concrete synergieën te creëren.",
    "pop.pillar_1.title": "Eerst lokaal",
    "pop.pillar_1.desc": "Sint-Agatha-Berchem en Brussel. Uw buurt, uw handelaars, uw buren.",
    "pop.pillar_2.title": "Minimale kosten",
    "pop.pillar_2.desc": "Deelnemen is gratis. Geen drempels, alleen impact.",
    "pop.pillar_3.title": "Maximale efficiëntie",
    "pop.pillar_3.desc": "Elke handelaar versterkt de buur, elke aanbieding verrijkt de gemeenschap.",
    "pop.punch": "Minimale kosten · Maximale efficiëntie · Samen.",
    "pop.cta": "Ik neem contact op",
    "pop.dismiss": "Ontdek de site",

    // Redeem popup
    "redeem.title": "Geniet van uw voordeel",
    "redeem.step_title": "In 2 seconden bij de handelaar:",
    "redeem.step_1": "Toon de actieve B.health®-app op uw smartphone",
    "redeem.step_2": "Vermeld de aanbieding aan de kassa",
    "redeem.step_3": "Profiteer meteen van uw korting",
    "redeem.tip": "Ga naar uw handelaar met de mobiele club-app en klaar is kees!",
    "redeem.close": "Begrepen, bedankt",
  },
};

export function format(str, vars = {}) {
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : ""));
}
